import api from '@/utils/api';

/**
 * Create user
 * @param {object} userData - The user data
 * @returns {Promise}
 */
const createUserApi = (userData) => api.post('/user', userData);

export default createUserApi;
